import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils';
import Polygon from '@arcgis/core/geometry/Polygon';
import IconButton from 'material-ui/IconButton';
import TrashIcon from 'material-ui/svg-icons/navigation/close';
import PolygonIcon from '../../../icons/Polygon';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SpatialFilterLibraryDialog from '../spatialFilter/SpatialFilterLibraryDialog';
//import Polygon from "@arcgis/core/geometry/Polygon";
import { filterOperations } from '../../../redux/filter';
import FormControl from '@material-ui/core/FormControl';

import { setMapViewTarget } from '../../esri/mapHub';

import theme from '../../../muiTheme';

const iconButtonStyles = {
  buttonStyle: {
    borderRadius: "50%",
    width: "36px",
    height: "36px",
    padding: "6px"
  },
  activeStyle: {
    backgroundColor: "#6f7482"
  },
  activeIconStyle: {
    color: theme.palette.canvasColor
  }
}

class LocationFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTool: null,
      isUploading: false,
      showShapeParseError: false,
      showShapeLibraryDialog: false,
      spatialFilters: []
    };
  }

  inputFileChanged = async (e) => {
    if (window.FileReader) {
      this.setState({
        isUploading: true
      });
    }

    let file = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
    this.generateFeatureCollection(file);
    this.refs.input_reader.value = null;
  }

  filterSelected = (filter) => {
        

      this.props.setGeometryFromShapefile(filter.geometry);
      this.props.setSpatialFilterID(filter.attributes.OBJECTID);

      let geomWGS84 = webMercatorUtils.webMercatorToGeographic(filter.geometry);

      setMapViewTarget({
        target: geomWGS84
      });

      this.onShapeLibraryDialogClose();
  }

  generateFeatureCollection = (file) => {
      var params = {
        name: file,
        targetSR: new SpatialReference(4269),
        maxRecordCount: 1000,
        enforceInputFileSizeLimit: true,
        enforceOutputJsonSizeLimit: true
      };

      // generalize features to 10 meters for better performance
      //TODO: These are being overwritten by the API call
      params.generalize = true;
      params.maxAllowableOffset = 5;
      params.reducePrecision = false;
      //params.numberOfDigitsAfterDecimal = 3;

      window.api.addFilterFromShapefile(params, file, "", "").then(spatialFilter => {
        if (spatialFilter) {
          const poly = new Polygon({
            rings: spatialFilter.geometry.rings,
            spatialReference: { wkid: 3857 }
          });
          this.props.setGeometryFromShapefile(poly);
          this.props.setSpatialFilterID(spatialFilter.attributes.OBJECTID);

          let geomWGS84 = webMercatorUtils.webMercatorToGeographic(spatialFilter.geometry);

          setMapViewTarget({
            target: geomWGS84
          });
        }
      }
      ).catch(err => {
        debugger;
        console.log("Oh noooo");
        this.setState({ showShapeParseError: true });
      });

  }


  polygonToolSelected = () => {
    if (this.props.filter.activeDrawTool === "polygon") {
      this.cancelSelectedTool();
    }
    else {
      this.props.setActiveDrawTool("polygon");
      this.props.onToolSelected("polygon");
    }
  }

  onShapeLibraryDialogClose = () => {
    this.setState({ showShapeLibraryDialog: false });
  }

  uploadShapefile = (event) => {
    this.setState({ showShapeLibraryDialog: true });

    window.api.getSpatialFiltersForUser().then(response => {
      this.setState({ spatialFilters: response });
    });

    /*event.preventDefault();
    let input = this.refs.input_reader;
    input.click();*/
  }
  setSpatialFilters = (filters) => {
    this.setState({ spatialFilters: filters });
  }

  removeGeometryToolSelected = () => {
    this.setState({ activeTool: null });
    this.props.onGeometryCleared();
  }

  cancelSelectedTool = () => {
    this.props.setActiveDrawTool(null);
    this.props.onToolCancel();
  }

  render() {
    const removeGeometry = (this.props.filter.geometry || this.props.filter.shapefileFilter) ? (
      <IconButton
        style={{ ...iconButtonStyles.buttonStyle }}
        iconStyle={{ width: "18px", color: theme.palette.borderColor }}
        tooltip="Reset Drawn Filter"
        tooltipPosition="top-left"
        onClick={this.removeGeometryToolSelected}>
        <TrashIcon />
      </IconButton>
    ) : null;

    let polygonSelectedStyle;
    let polygonIconSelectedStyle;
    if (this.props.filter.activeDrawTool === "polygon") {
      polygonSelectedStyle = iconButtonStyles.activeStyle;
      polygonIconSelectedStyle = iconButtonStyles.activeIconStyle;
    }

    return (
      <div className="filter-item-geometry">
        <label>{this.props.label}:</label>
        <div className="filter-item-location-tools">
          <FormControl>
            <input type="file" ref="input_reader" accept=".zip" multiple={false} style={{ display: 'none' }} onChange={this.inputFileChanged} />
            <div class="filter-item-numeric-range"><IconButton
              style={{ ...iconButtonStyles.buttonStyle, ...polygonSelectedStyle }}
              iconStyle={{ width: "18px", color: theme.palette.borderColor, ...polygonIconSelectedStyle }}
              tooltip="Polygon Tool"
              tooltipPosition="top-center"
              onClick={this.polygonToolSelected}>
              <PolygonIcon />
            </IconButton>
              <IconButton
                style={{ ...iconButtonStyles.buttonStyle, ...polygonSelectedStyle }}
                iconStyle={{ width: "24px", color: theme.palette.borderColor, ...polygonIconSelectedStyle }}
                tooltip="Filter Library"
                tooltipPosition="top-center"
                onClick={this.uploadShapefile}>
                <UploadFileIcon />
              </IconButton>
            </div>
          </FormControl>
        </div>
        <div className="filter-item-location-clear">
          {removeGeometry}
        </div>
        <SpatialFilterLibraryDialog open={this.state.showShapeLibraryDialog} setSpatialFilters={this.setSpatialFilters} onFilterSelected={this.filterSelected} spatialFilters={this.state.spatialFilters} onClose={this.onShapeLibraryDialogClose} />
      </div>
    );
  }

}

const mapStateToProps = state => ({
  map: state.map,
  appConfig: state.config,
  filter: state.filter
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...filterOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationFilter)
